/**
 * Warranty Exclusivity - Cart Add/Remove Handlers
 * TRUE MUTUAL EXCLUSIVITY: Only ONE warranty per parent product
 * 
 * Supported: AppleCare (aplcr), SecWarranty (secwr), Secoia, Secoia2ans
 * 
 * v2
 * 
 * Changes from v1:
 * - Use key-based cart updates (id) instead of line-based for reliability
 * - Preserve _added_from_pdp, SKU, Barcode, _item_token, bundle properties on parent updates
 * - Fixed bug: Secoia REMOVE handler was missing $removeBtn variable declaration
 * - buildCleanParentProperties now preserves SKU, Barcode, _added_from_pdp, _item_token, bundle props
 * 
 */

(function() {
  'use strict';

  var warrantyOperationInProgress = false;

  // WARRANTY CONFIGURATION
  
  var WARRANTY_CONFIG = {
    aplcr: {
      name: 'AppleCare',
      parentSkuProp: '_applecare_sku',
      parentHandleProp: '_applecare_handle',
      itemSkuProp: '_aplcr_main_product_sku',
      itemHandleProp: '_aplcr_main_product_handle'
    },
    secwr: {
      name: 'Secondary Warranty',
      parentSkuProp: '_secWarranty_sku',
      parentHandleProp: '_secWarranty_handle',
      itemSkuProp: '_sw_main_product_sku',
      itemHandleProp: '_sw_main_product_handle'
    },
    secoia: {
      name: 'Secoia',
      parentSkuProp: '_secoia_sku',
      parentHandleProp: '_secoia_handle',
      itemSkuProp: '_secoia_main_product_sku',
      itemHandleProp: '_secoia_main_product_handle'
    },
    secoia2ans: {
      name: 'Secoia 2 ans',
      parentSkuProp: '_secoia2ans_sku',
      parentHandleProp: '_secoia2ans_handle',
      itemSkuProp: '_secoia2ans_main_product_sku',
      itemHandleProp: '_secoia2ans_main_product_handle'
    }
  };


  // HELPER: Update cart item by key (more reliable than line-based)

  async function updateCartItemByKey(key, quantity, properties) {
    return $.ajax({
      url: window.Shopify.routes.root + 'cart/change.js',
      type: 'POST',
      data: JSON.stringify({
        id: key,
        quantity: quantity,
        properties: properties
      }),
      contentType: 'application/json',
      dataType: 'json'
    });
  }


  // HELPER: Find ALL warranty items in cart for a parent SKU

  function findAllWarrantiesForParent(cartData, parentSku) {
    var found = [];
    
    for (var i = 0; i < cartData.items.length; i++) {
      var item = cartData.items[i];
      
      if (!item.properties) {
        continue;
      }
      
      // Check each warranty type
      for (var type in WARRANTY_CONFIG) {
        var config = WARRANTY_CONFIG[type];
        var itemParentSku = item.properties[config.itemSkuProp];
        
        if (itemParentSku && itemParentSku === parentSku) {
          found.push({
            type: type,
            key: item.key,
            item: item,
            line: i + 1
          });
          break; // Item can only be one warranty type
        }
      }
    }
    
    return found;
  }


  // HELPER: Remove ALL other warranties for THIS SPECIFIC PARENT (by UUID)

  async function removeAllOtherWarranties(parentSku, parentUuid, keepType) {
    var cartData = await $.ajax({
      url: window.Shopify.routes.root + 'cart.js',
      type: 'GET',
      dataType: 'json'
    });
    
    // Build batch update object
    var updates = {};
    
    for (var i = 0; i < cartData.items.length; i++) {
      var item = cartData.items[i];
      if (!item.properties) continue;
      
      for (var type in WARRANTY_CONFIG) {
        if (type === keepType) continue;
        
        var config = WARRANTY_CONFIG[type];
        var itemParentSku = item.properties[config.itemSkuProp];
        
        if (itemParentSku === parentSku && item.properties._uuid === parentUuid) {
          updates[item.key] = 0; // Mark for removal
          break;
        }
      }
    }
    
    // Single batch request instead of multiple
    if (Object.keys(updates).length > 0) {
      await $.ajax({
        type: 'POST',
        url: window.Shopify.routes.root + 'cart/update.js',
        data: { updates: updates },
        dataType: 'json'
      });
    }
    
    return Object.keys(updates).length;
  }


  // HELPER: Clean parent properties - remove ALL warranty props, add only the new one
  // Preserves: _added_from_pdp, SKU, Barcode, _item_token, _cto_product, bundle props, etc.
  
  function buildCleanParentProperties(existingProps, newWarrantyType, newSku, newHandle) {
    var cleanProps = {};
    
    if (existingProps) {
      for (var prop in existingProps) {
        if (!existingProps.hasOwnProperty(prop)) continue;
        
        // Check if this is ANY warranty property
        var isWarrantyProp = false;
        for (var type in WARRANTY_CONFIG) {
          var config = WARRANTY_CONFIG[type];
          if (prop === config.parentSkuProp || prop === config.parentHandleProp) {
            isWarrantyProp = true;
            break;
          }
        }
        
        // Keep only non-warranty properties
        // This automatically preserves: _added_from_pdp, SKU, Barcode, _item_token,
        // _cto_product, _bundle_uuid, _bundle_title, _bundle_handle, _bundle_product_id,
        // _bundle_price, _bundle_item_*_id, _bundle_item_*_price, etc.
        if (!isWarrantyProp) {
          cleanProps[prop] = existingProps[prop];
        }
      }
    }
    
    // Add ONLY the new warranty properties
    if (newWarrantyType && WARRANTY_CONFIG[newWarrantyType]) {
      var newConfig = WARRANTY_CONFIG[newWarrantyType];
      cleanProps[newConfig.parentSkuProp] = newSku;
      cleanProps[newConfig.parentHandleProp] = newHandle;
    }
    
    return cleanProps;
  }


  // MAIN ADD HANDLER
  
  async function handleWarrantyAdd($btn, warrantyType) {
    var config = WARRANTY_CONFIG[warrantyType];
    
    if (!config) {
      console.error('Unknown warranty type:', warrantyType);
      return;
    }
    
    if (warrantyOperationInProgress) {
      return;
    }
    
    if ($btn.prop('disabled') || $btn.hasClass('force-disabled')) {
      return;
    }
    
    warrantyOperationInProgress = true;

    // Disables add-on buttons, remove buttons, and view cart buttons
    if (window.toggleAddOnButtons) window.toggleAddOnButtons('disable');
    $btn.prop('disabled', true);
    $btn.addClass('force-disabled');
    
    // Get all button data
    var variantId = $btn.data('variantid');
    var skuParent = $btn.data('skuparent');
    var handleParent = $btn.data('handleparent');
    var keyParent = $btn.data('keyparent');
    var parentUuid = $btn.data('uuid');
    var handleWarranty = $btn.data('handleaplcr');
    var skuWarranty = $btn.data('skuaplcr');
    var preorderParent = $btn.data('preorderparent');
    var preorderMessageParent = $btn.data('preordermessageparent');
    var tradeinParent = $btn.data('tradeinparent');
    var forwKeyGwp = $btn.data('forwkeygwp');


    try {
      // ===== STEP 1: REMOVE ALL OTHER WARRANTIES FOR THIS PARENT =====

      await removeAllOtherWarranties(skuParent, parentUuid, warrantyType);
      
      // ===== STEP 2: Get fresh cart data =====

      var cartData = await $.ajax({
        url: window.Shopify.routes.root + 'cart.js',
        type: 'GET',
        dataType: 'json'
      });
      
      // ===== STEP 3: Find parent item =====

      var parentItem = null;
      
      // Try by key first
      for (var i = 0; i < cartData.items.length; i++) {
        if (cartData.items[i].key === keyParent) {
          parentItem = cartData.items[i];
          break;
        }
      }
      
      // Try by SKU if not found
      if (!parentItem && skuParent) {
        for (var i = 0; i < cartData.items.length; i++) {
          var item = cartData.items[i];
          if (item.sku === skuParent) {
            // Make sure it's not a warranty item
            var isWarranty = false;
            for (var type in WARRANTY_CONFIG) {
              if (item.properties && item.properties[WARRANTY_CONFIG[type].itemSkuProp]) {
                isWarranty = true;
                break;
              }
            }
            if (!isWarranty) {
              parentItem = item;
              break;
            }
          }
        }
      }
      
      if (!parentItem) {
        throw new Error('Parent item not found in cart');
      }
      
      var parentQuantity = parentItem.quantity || 1;

      // ===== STEP 4: Check if this warranty already exists FOR THIS SPECIFIC PARENT =====

      var thisParentWarranty = null;

      for (var i = 0; i < cartData.items.length; i++) {
        var item = cartData.items[i];
        
        if (!item.properties) continue;
        
        // Check if this is a warranty item
        var itemParentSku = item.properties[config.itemSkuProp];
        if (!itemParentSku) continue;
        
        // Check if it's linked to the same parent SKU
        if (itemParentSku !== skuParent) continue;
        
        // Check if it has the SAME UUID as the parent we're working with
        if (item.properties._uuid !== parentUuid && item.properties._uuid !== parentItem.properties._uuid) {
          continue;
        }
        
        // Check if it's the warranty type we're trying to add
        for (var type in WARRANTY_CONFIG) {
          if (type === warrantyType) {
            var checkConfig = WARRANTY_CONFIG[type];
            if (item.properties[checkConfig.itemSkuProp] === skuParent) {
              thisParentWarranty = item;
              break;
            }
          }
        }
        
        if (thisParentWarranty) break;
      }

      if (thisParentWarranty) {
        warrantyOperationInProgress = false;
        $btn.prop('disabled', false);
        $btn.removeClass('force-disabled');
        if (window.toggleAddOnButtons) window.toggleAddOnButtons('enable');
        if (window.onCartUpdate) window.onCartUpdate();
        return;
      }

      // ===== STEP 5: Build new UUID =====

      var newUuid = handleParent;
      
      if (handleWarranty) {
        newUuid = newUuid + '-' + handleWarranty;
      }
      
      // Preserve GWP in UUID
      if (parentItem.properties && parentItem.properties._gwp_handle) {
        newUuid = newUuid + '-' + btoa(Math.random()).substring(0, 8);
      }
      
      // Preserve trade-in
      if (parentItem.properties && parentItem.properties._tradeIn_device) {
        if (!newUuid.includes('-tradein')) {
          newUuid = newUuid + '-tradein';
        }
      }
      
      
      // ===== STEP 6: Update parent with ONLY new warranty =====
      // buildCleanParentProperties preserves all non-warranty props automatically,
      // including: _added_from_pdp, SKU, Barcode, _item_token, bundle props, etc.

      var parentProperties = buildCleanParentProperties(
        parentItem.properties,
        warrantyType,
        skuWarranty,
        handleWarranty
      );
      
      parentProperties._uuid = newUuid;
      
      // Preserve other important properties that buildCleanParentProperties
      // already keeps (these are safety fallbacks for button-sourced data)
      if (preorderParent === true || preorderParent === 'true') {
        parentProperties._preOrder = 'true';
      }
      if (preorderMessageParent) {
        parentProperties._preOrderMessage = preorderMessageParent;
      }
      if (tradeinParent === true || tradeinParent === 'true') {
        parentProperties._tradeInEligible = 'true';
      }
      if (parentItem.properties && parentItem.properties._tradeIn_value) {
        parentProperties._tradeIn_value = parentItem.properties._tradeIn_value;
      }
      if (parentItem.properties && parentItem.properties._tradeIn_device) {
        parentProperties._tradeIn_device = parentItem.properties._tradeIn_device;
      }
      if (parentItem.properties && parentItem.properties._cto_product) {
        parentProperties._cto_product = 'true';
      }
      // Preserve _added_from_pdp (new in updated cart.js)
      if (parentItem.properties && parentItem.properties._added_from_pdp) {
        parentProperties._added_from_pdp = 'true';
      }
      if (parentItem.properties && parentItem.properties._gwp_sku) {
        parentProperties._gwp_sku = parentItem.properties._gwp_sku;
        parentProperties._gwp_handle = parentItem.properties._gwp_handle;
      }
      // Preserve _item_token (new in updated cart.js)
      if (parentItem.properties && parentItem.properties._item_token) {
        parentProperties._item_token = parentItem.properties._item_token;
      }
      
      // Use key-based update for reliability (lines can shift between operations)
      cartData = await updateCartItemByKey(parentItem.key, parentQuantity, parentProperties);
      
      // ===== STEP 7: Add the warranty product =====

      var warrantyProperties = {
        _uuid: newUuid
      };
      
      warrantyProperties[config.itemSkuProp] = skuParent;
      warrantyProperties[config.itemHandleProp] = handleParent;
      
      // For Secoia types, also add warranty's own sku/handle
      if (warrantyType === 'secoia' || warrantyType === 'secoia2ans') {
        warrantyProperties[config.parentSkuProp] = skuWarranty;
        warrantyProperties[config.parentHandleProp] = handleWarranty;
      }
      
      
      await $.ajax({
        url: window.Shopify.routes.root + 'cart/add.js',
        type: 'POST',
        data: {
          id: variantId,
          quantity: parentQuantity,
          properties: warrantyProperties
        },
        dataType: 'json'
      });

      
      // ===== STEP 8: Update GWP if exists =====
      if (forwKeyGwp && forwKeyGwp !== '') {
        
        cartData = await $.ajax({
          url: window.Shopify.routes.root + 'cart.js',
          type: 'GET',
          dataType: 'json'
        });
        
        var gwpKeys = forwKeyGwp.toString().split(',');
        
        for (var g = 0; g < gwpKeys.length; g++) {
          var gwpKey = gwpKeys[g];
          if (!gwpKey || gwpKey === '') continue;
          
          var gwpItem = null;
          
          for (var i = 0; i < cartData.items.length; i++) {
            if (cartData.items[i].key === gwpKey) {
              gwpItem = cartData.items[i];
              break;
            }
          }
          
          if (gwpItem) {
            var gwpProps = {};
            if (gwpItem.properties) {
              for (var prop in gwpItem.properties) {
                if (gwpItem.properties.hasOwnProperty(prop)) {
                  gwpProps[prop] = gwpItem.properties[prop];
                }
              }
            }
            gwpProps._uuid = newUuid;
            
            // Use key-based update for GWP as well
            cartData = await updateCartItemByKey(gwpItem.key, gwpItem.quantity, gwpProps);
          }
        }
      }

      
      warrantyOperationInProgress = false;
      
      window.setTimeout(function() {
        if (window.onCartUpdate) {
          window.onCartUpdate();
        } else {
          location.reload();
        }
      }, 100);
      
    } catch (err) {
      console.error('=== ' + config.name.toUpperCase() + ' ADD ERROR ===', err);
      alert('Erreur lors de l\'ajout de la garantie ' + config.name + '.');
      warrantyOperationInProgress = false;
      $btn.prop('disabled', false);
      $btn.removeClass('force-disabled');
      if (window.toggleAddOnButtons) window.toggleAddOnButtons('enable');
    }
  }


  // MAIN REMOVE HANDLER

  async function handleWarrantyRemove($removeBtn, warrantyType) {
    var config = WARRANTY_CONFIG[warrantyType];
    
    if (!config) {
      console.error('Unknown warranty type:', warrantyType);
      return;
    }
    
    if (warrantyOperationInProgress) {
      return;
    }
    
    warrantyOperationInProgress = true;
    
    var cartKey = $removeBtn.data('cartkey');
    var parentSku = $removeBtn.data('skuparent');
    var parentUuid = $removeBtn.data('uuid');
    
    if (!cartKey) {
      console.error('No cart key for removal');
      warrantyOperationInProgress = false;
      return;
    }

    
    // Disables add-on buttons, remove buttons, and view cart buttons
    if (window.toggleAddOnButtons) window.toggleAddOnButtons('disable');

    try {
      // Step 1: Remove warranty product (key-based)
      await $.ajax({
        type: 'POST',
        url: window.Shopify.routes.root + 'cart/change.js',
        data: {
          id: cartKey,
          quantity: 0
        },
        dataType: 'json'
      });
      
      // Step 2: Update parent
      var cartData = await $.ajax({
        url: window.Shopify.routes.root + 'cart.js',
        type: 'GET',
        dataType: 'json'
      });
      
      // Find parent
      var parentItem = null;
      
      for (var i = 0; i < cartData.items.length; i++) {
        var item = cartData.items[i];
        
        // Check it's not a warranty
        var isWarranty = false;
        for (var type in WARRANTY_CONFIG) {
          if (item.properties && item.properties[WARRANTY_CONFIG[type].itemSkuProp]) {
            isWarranty = true;
            break;
          }
        }
        if (isWarranty) continue;
        
        // Check it has this warranty's properties
        if (!item.properties || !item.properties[config.parentSkuProp]) continue;
        
        // Match by SKU
        if (parentSku && item.sku === parentSku) {
          parentItem = item;
          break;
        }
      }
      
      if (parentItem) {
        // Remove warranty properties from parent
        // All non-warranty props (_added_from_pdp, SKU, Barcode, _item_token,
        // _cto_product, bundle props) are preserved automatically
        var newProps = {};
        for (var prop in parentItem.properties) {
          if (!parentItem.properties.hasOwnProperty(prop)) continue;
          if (prop === config.parentSkuProp || prop === config.parentHandleProp) {
            continue;
          }
          newProps[prop] = parentItem.properties[prop];
        }
        
        // Update UUID
        if (newProps._uuid && parentItem.properties[config.parentHandleProp]) {
          var warrantyHandle = parentItem.properties[config.parentHandleProp];
          newProps._uuid = newProps._uuid.replace('-' + warrantyHandle, '');
        }
        
        // Use key-based update for reliability
        await updateCartItemByKey(parentItem.key, parentItem.quantity, newProps);
      }
      
      warrantyOperationInProgress = false;
      
      window.setTimeout(function() {
        if (window.onCartUpdate) {
          window.onCartUpdate();
        } else {
          location.reload();
        }
      }, 100);
      
    } catch (err) {
      console.error('=== ' + config.name.toUpperCase() + ' REMOVE ERROR ===', err);
      warrantyOperationInProgress = false;
      if (window.toggleAddOnButtons) window.toggleAddOnButtons('enable');
      location.reload();
    }
  }


  // EVENT HANDLERS - Based on ACTUAL HTML selectors

  // Remove ALL existing handlers to avoid conflicts
  $(document).off('click.warrantyExclusive');
  $(document).off('click', '.add-cart-apple-care');
  $(document).off('click', '.apl-section-cart-secoia-add-remove');
  $(document).off('click', '.apl-section-cart-secoia2ans-add-remove');


  // AppleCare (aplcr) & SecWarranty (secwr) ADD
  // Selector: .add-cart-apple-care with data-reference
  $(document).on('click.warrantyExclusive', '.add-cart-apple-care', function(e) {
    var $btn = $(this);
    
    // Skip if inside cart-remove-button (those are remove buttons, not add)
    if ($btn.closest('cart-remove-button').length > 0) {
      return;
    }
    
    var reference = $btn.data('reference');
    
    if (reference === 'aplcr') {
      e.preventDefault();
      e.stopImmediatePropagation();
      handleWarrantyAdd($btn, 'aplcr');
      return false;
    } else if (reference === 'secwr') {
      e.preventDefault();
      e.stopImmediatePropagation();
      handleWarrantyAdd($btn, 'secwr');
      return false;
    }
    // Let other handlers deal with other references (gwp, etc.)
  });


  // Secoia ADD
  // Selector: .apl-section-cart-secoia-add-remove with data-reference="secoia"
  $(document).on('click.warrantyExclusive', '.apl-section-cart-secoia-add-remove', function(e) {
    var $btn = $(this);
    
    // Skip if inside cart-remove-button
    if ($btn.closest('cart-remove-button').length > 0) {
      return;
    }
    
    // Check row state
    var $row = $btn.closest('tr[data-secoia-state]');
    if ($row.length > 0 && $row.data('secoia-state') === 'in-cart') {
      return;
    }
    
    var reference = $btn.data('reference');
    if (reference !== 'secoia') {
      return;
    }
    
    e.preventDefault();
    e.stopImmediatePropagation();
    handleWarrantyAdd($btn, 'secoia');
    return false;
  });


  // Secoia 2 ans ADD
  // Selector: .apl-section-cart-secoia2ans-add-remove with data-reference="secoia2ans"
  $(document).on('click.warrantyExclusive', '.apl-section-cart-secoia2ans-add-remove', function(e) {
    var $btn = $(this);
    
    // Skip if inside cart-remove-button
    if ($btn.closest('cart-remove-button').length > 0) {
      return;
    }
    
    // Check row state
    var $row = $btn.closest('tr[data-secoia2ans-state]');
    if ($row.length > 0 && $row.data('secoia2ans-state') === 'in-cart') {
      return;
    }
    
    var reference = $btn.data('reference');
    if (reference !== 'secoia2ans') {
      return;
    }
    
    e.preventDefault();
    e.stopImmediatePropagation();
    handleWarrantyAdd($btn, 'secoia2ans');
    return false;
  });


  // SecWarranty REMOVE
  // Selector from HTML: data-typeofbutton="swremove"
  $(document).on('click.warrantyExclusive', 'cart-remove-button[data-typeofbutton="swremove"] a', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var $removeBtn = $(this).closest('cart-remove-button');
    handleWarrantyRemove($removeBtn, 'secwr');
    return false;
  });


  // Secoia REMOVE
  // Selector from HTML: data-typeofbutton="secoiaremove"
  $(document).on('click.warrantyExclusive', 'cart-remove-button[data-typeofbutton="secoiaremove"] a', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var $removeBtn = $(this).closest('cart-remove-button');
    handleWarrantyRemove($removeBtn, 'secoia');
    return false;
  });


  // Secoia 2 ans REMOVE
  // Selector from HTML: data-typeofbutton="secoia2ansremove"
  $(document).on('click.warrantyExclusive', 'cart-remove-button[data-typeofbutton="secoia2ansremove"] a', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var $removeBtn = $(this).closest('cart-remove-button');
    handleWarrantyRemove($removeBtn, 'secoia2ans');
    return false;
  });


  // Reset flag on cart update  
  $(document).on('cart:updated', function() {
    warrantyOperationInProgress = false;
  });

})();